import { render } from "./ClockIcon2.vue?vue&type=template&id=475c804b&scoped=true"
import script from "./ClockIcon2.vue?vue&type=script&lang=js"
export * from "./ClockIcon2.vue?vue&type=script&lang=js"

import "./ClockIcon2.vue?vue&type=style&index=0&id=475c804b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-475c804b"]])

export default __exports__